import { handleActions } from 'redux-actions'
import Type from './ActionType'
import { TreeNode } from './actions'

const state = {
    treeMap: new Map() as Map<number, TreeNode>,
    treeId: -1,
    treeExpandKeyMap: new Map() as Map<number, Set<number>>,
    trendMap: new Map() as Map<number, string[]>,
    listLoading: false,
    totalNum: 0,
    /// 标签集市的选中人群
    crowdConditions: [] as TreeNode[], 
    /// 创建人群时组合结果中的条件
    logicConditions: [] as TreeNode[], 
    expandTreeMap: new Map() as Map<number, any>
}

export type LabelMarketState = typeof state

export default handleActions<LabelMarketState>({
    [Type.UPDATE_STATE] (state,  { payload }) {
        for (let key in payload) {
            if (!state.hasOwnProperty(key)) {
                console.error(`SASS-DMP[ERROR]: can't find ${key} property in LabelMarketState`)
            }
        }
            
        
        return Object.assign({}, state, payload)
    },
}, state)


